import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import StyledTableRow from "app/Components/Tables/StyledTableRow";
import PrimaryTableCell from "app/Components/Tables/PrimaryTableCell";
import TableBody from "@mui/material/TableBody";

import {
  IconButton,
  Tooltip,
  Box,
} from "@mui/material";

import {
  CheckCircle,
  MessageOutlined,
  DeleteOutline,
} from "@mui/icons-material";

import DB from "_DatabaseFunctions/directConnect";

import {
  formatDate,
  unixToMins,
  createHash,
  createSortedKeyMap,
} from "utils/helperFunctions";

const useStyles = makeStyles(() => ({
  tableCell: {
    textAlign: "center",
    margin: "auto",
    padding: "auto",
  },
}));

interface RootState {
  host: {
    gamelist: {
      [key: string]: {
        currentPlayers: {
          [key: string]: any;
        };
        playerlist: {
          [key: string]: {
            id: string;
            displayName: string;
            timeStamp: number;
          };
        };
      };
    };
  };
  requests: {
    receivedRequests: {
      [key: string]: {
        status: string;
      };
    };
  };
}

interface Props {
  setModalDets: (dets: {
    open: boolean;
    status: string;
    playerData: {
      id: string;
      displayName: string;
    };
  }) => void;
}

const CurrentPlayersTableBody = (props: Props) => {
  const { setModalDets } = props;
  const classes = useStyles();
  const navigate = useNavigate();
  const { gameId } = useParams<{ gameId: string }>();
  const gamelist = useSelector((state: RootState) => state.host.gamelist);
  const gameInfo = gameId ? gamelist[gameId] : null;
  const receivedRequests = useSelector(
    (state: RootState) => state.requests.receivedRequests,
  );

  const [time, setTime] = useState<number>(0);

  useEffect(() => {
    const timerID = window.setInterval(() => tick(), 1000);
    return function cleanup() {
      window.clearInterval(timerID);
    };
  }, []);

  const tick = () => {
    setTime(Date.now());
  };

  const convertSeconds = (unixtime: number, playerId: string) => {
    if (unixtime < 0 && gameId) {
      const reqId = createHash(playerId + gameId);
      DB.removePlayerFromGame(gameId, playerId);
      DB.deleteRequest(reqId);
    } else {
      return unixToMins(unixtime);
    }
  };

  const renderPlayerlistTableData = () => {
    if (gameInfo && gameId) {
      const { currentPlayers } = gameInfo;
      const SortedMap = createSortedKeyMap(gameInfo.playerlist, "timeStamp");
      const playerKeys = Object.keys(SortedMap);
      
      console.log("Debug - currentPlayers:", currentPlayers);
      console.log("Debug - SortedMap:", SortedMap);
      console.log("Debug - playerKeys:", playerKeys);
      
      return playerKeys.map((playerKey, index) => {
        if (!currentPlayers[playerKey]) return null;
        const playerData = SortedMap[playerKey];
        const reqId = createHash(playerData.id + gameId);
        const reqData = receivedRequests[reqId];
        return (
          <StyledTableRow key={playerData.id}>
            <PrimaryTableCell>{playerData.displayName} </PrimaryTableCell>
            <PrimaryTableCell>
              {reqData && reqData.status === "confirmationPending" ? (
                <div style={{ color: "red" }}>
                  Confirmation Needed
                  <div>
                    {convertSeconds(playerData.timeStamp - time, playerData.id)}
                  </div>
                </div>
              ) : (
                formatDate(playerData.timeStamp)
              )}
            </PrimaryTableCell>
            <PrimaryTableCell>
              <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                {playerData.id.substring(0, 4) !== "Host" && (
                  <Tooltip title="Message Player">
                    <span>
                      <IconButton
                        onClick={() => navigate(`/messages/${playerData.id}`)}
                        size="small"
                        sx={{
                          bgcolor: 'info.light',
                          color: 'white',
                          width: 32,
                          height: 32,
                          '&:hover': {
                            bgcolor: 'info.main',
                          },
                        }}
                      >
                        <MessageOutlined fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
                
                {reqData && reqData.status === "confirmationPending" && (
                  <Tooltip title="Confirm Player's Seat Now">
                    <span>
                      <IconButton
                        onClick={() => {
                          setModalDets({
                            open: true,
                            status: "confirmPlayer",
                            playerData,
                          });
                        }}
                        size="small"
                        sx={{
                          bgcolor: 'warning.light',
                          color: 'white',
                          width: 32,
                          height: 32,
                          '&:hover': {
                            bgcolor: 'warning.main',
                          },
                        }}
                      >
                        <CheckCircle fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
                
                <Tooltip title="Remove Player from Table">
                  <span>
                    <IconButton
                      onClick={() => {
                        setModalDets({
                          open: true,
                          status: "removePlayer",
                          playerData,
                        });
                      }}
                      size="small"
                      sx={{
                        bgcolor: 'error.light',
                        color: 'white',
                        width: 32,
                        height: 32,
                        '&:hover': {
                          bgcolor: 'error.main',
                        },
                      }}
                    >
                      <DeleteOutline fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
              </Box>
            </PrimaryTableCell>
          </StyledTableRow>
        );
      });
    }
  };

  return <TableBody>{renderPlayerlistTableData()}</TableBody>;
};

export default CurrentPlayersTableBody;
